import supabase from '../supabase/supabase';

const messageTime = (message) => {
  const value = message?.created_at || message?.timestamp || message?.createdAt;
  const timestamp = new Date(value || 0).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

const normalizeChat = (chat, userId) => {
  const messages = [...(chat.messages || [])].sort((left, right) => messageTime(left) - messageTime(right));
  const isProvider = String(chat.providerId) === String(userId);
  const readAt = isProvider ? chat.provider_read_at : chat.requester_read_at;
  const counterpartyReadAt = isProvider ? chat.requester_read_at : chat.provider_read_at;
  const readTimestamp = new Date(readAt || 0).getTime();

  const unreadCount = messages.reduce((total, message) => {
    const isOwnMessage = String(message.senderId) === String(userId);
    return !isOwnMessage && messageTime(message) > readTimestamp ? total + 1 : total;
  }, 0);

  return {
    ...chat,
    messages,
    unreadCount,
    readAt,
    counterpartyReadAt,
    isAnonymized: Boolean(chat.anonymized_at),
  };
};

export const chatService = {
  async getMyChats(userId) {
    const { data, error } = await supabase
      .from('chats')
      .select(`
        *,
        messages (*)
      `)
      .or(`providerId.eq.${userId},requesterId.eq.${userId}`)
      .order('updated_at', { ascending: false });

    if (error) throw error;
    return (data || []).map((chat) => normalizeChat(chat, userId));
  },

  async createChat(listing) {
    if (!listing?.id) throw new Error('Das Angebot wurde nicht gefunden.');

    const { data, error } = await supabase.rpc('start_chat', {
      p_listing_id: listing.id,
    });

    if (error) throw error;
    return data;
  },

  async sendMessage(chatId, senderId, text) {
    const messageText = String(text || '').trim();
    if (!chatId) throw new Error('Der Chat wurde nicht gefunden.');
    if (!senderId) throw new Error('Bitte melde dich erneut an.');
    if (!messageText) throw new Error('Bitte gib eine Nachricht ein.');
    if (messageText.length > 4000) throw new Error('Die Nachricht darf höchstens 4.000 Zeichen lang sein.');

    const { data, error } = await supabase
      .from('messages')
      .insert([{
        chatId,
        senderId,
        text: messageText,
      }])
      .select()
      .single();

    if (error) throw error;

    return {
      ...data,
      timestamp: data.timestamp || data.created_at || new Date().toISOString(),
    };
  },

  async markRead(chatId) {
    if (!chatId) return null;
    const { data, error } = await supabase.rpc('mark_chat_read', {
      p_chat_id: chatId,
    });
    if (error) throw error;
    return data;
  },
};
